import { profile } from "../stores/storages/ProfileStorage.js";
import { $iq, $msg } from "./builder.js";
import * as MC_CONST from "./constants.js";
import MessagesUtil from "./messagesUtils.js";
import { Topic } from "./topic.js";
import { serialize } from "./utils2.js";

export class MessageXmpp {
  constructor(id) {
    this.id = id
  }
  createMessageReact(msg, motionId, type) {
    const { topic, from, id } = msg;
    const xml = $msg({
      id: this.id,
      to: `${Topic.getThreadId(topic)}@reeng/reeng`,
      type: MC_CONST.NODE_TYPE_MESSAGE.CHAT,
      subtype: MC_CONST.NODE_SUBTYPE_MESSAGE.EVENT,
      f_opr: profile.opr
    }).c(MC_CONST.NODE_NAME_XMPP.IDREF, {}, id);
    if (type === 'add') {
      xml.c(
        MC_CONST.NODE_TAG_NAME.REACT,
        {
          add: motionId,
          owner: Topic.getThreadId(from),
        },
        ""
      )
    } else {
      xml.c(
        MC_CONST.NODE_TAG_NAME.REACT,
        {
          remove: motionId,
          owner: Topic.getThreadId(from),
        },
        ""
      )
    }
    return serialize(xml);
  }

  createMessagePin() { }
  createIqMakeAdmin() { }

  createIqKick() { }
}

export class MessageXmppGrp extends MessageXmpp {
  createMessageReact(msg, motionId, type) {
    const { topic, from, id } = msg;
    const xml = $msg({
      id: this.id,
      to: `${Topic.getThreadId(topic)}@muc.reeng`,
      type: MC_CONST.NODE_TYPE_MESSAGE.GROUPCHAT,
      subtype: MC_CONST.NODE_SUBTYPE_MESSAGE.EVENT,
      member: profile.username
    })
      .c(MC_CONST.NODE_NAME_XMPP.IDREF, {}, id);
    if (type === 'add') {
      xml.c(
        MC_CONST.NODE_TAG_NAME.REACT,
        {
          add: motionId,
          owner: Topic.getThreadId(from),
        },
        ""
      )
    } else {
      xml.c(
        MC_CONST.NODE_TAG_NAME.REACT,
        {
          remove: motionId,
          owner: Topic.getThreadId(from),
        },
        ""
      )
    }
    return serialize(xml);
  }

  createMessagePin(msg, action) {
    const { topic, content, id, from } = msg;
    const context = typeof content === 'string' ? content : typeof content.replyBody ? content.replyBody : ''
    const xml = $msg({
      id: this.id,
      to: `${Topic.getThreadId(topic)}@muc.reeng`,
      type: MC_CONST.NODE_TYPE_MESSAGE.GROUPCHAT,
      subtype: MC_CONST.NODE_SUBTYPE_MESSAGE.PIN_MSG,
      member: profile.username,
      f_opr: profile.opr,
      from: `${profile.username}@reeng/desktop`
    }).c(
      MC_CONST.NODE_NAME_XMPP.BODY,
      {},
      context
    ).c(
      MC_CONST.NODE_NAME_XMPP.PIN,
      {
        action: action,
        type: 1,
        target: id,
        title: Topic.getThreadId(from)
      },
      ""
    )
    return serialize(xml);
  }

  createIqMakeAdmin(topic, jid, role) {
    const xml = $iq({
      id: this.id,
      to: `${Topic.getThreadId(topic)}@muc.reeng`,
      type: MC_CONST.NODE_TYPE_IQ.SET
    }).c(
      MC_CONST.NODE_NAME_XMPP.QUERY,
      {
        xmlns: 'makeAdmin'
      }
    ).c(
      MC_CONST.NODE_NAME_XMPP.MEMBER,
      {
        jid: jid,
        role: role
      },
      ""
    )
    return serialize(xml);
  }

  createIqKick(topic, jid, role) {
    const xml = $iq({
      id: this.id,
      to: `${Topic.getThreadId(topic)}@muc.reeng`,
      type: MC_CONST.NODE_TYPE_IQ.SET
    }).c(
      MC_CONST.NODE_NAME_XMPP.QUERY,
      {
        xmlns: 'kick'
      }
    ).c(
      MC_CONST.NODE_NAME_XMPP.MEMBER,
      {
        jid: jid,
        role: role
      },
      ""
    )
    return serialize(xml);
  }

}